import { all, fork, put, select, takeLatest } from 'redux-saga/effects';
import {
  ACTION_GET_NOTIFICATIONS,
  ACTION_MARK_NOTIFICATION_READ,
  ACTION_REFRESH_NOTIFICATIONS,
  getNotificationsAPI,
  markNotificationReadAPI,
  REQUEST_GET_NOTIFICATIONS_SUCCESS,
  REQUEST_MARK_NOTIFICATION_READ_SUCCESS,
} from '.';

function* getNotifications() {
  yield takeLatest([ACTION_GET_NOTIFICATIONS], function* (action) {
    const { page = 1, limit = 10 } = action.payload || {};
    yield put(getNotificationsAPI(page, limit));
  });
}

function* markNotificationRead() {
  yield takeLatest([ACTION_MARK_NOTIFICATION_READ], function* (action) {
    const { ids } = action.payload || {};
    if (ids && (Array.isArray(ids) || ids === 'all')) {
      yield put(markNotificationReadAPI(Array.isArray(ids) ? ids : ['all']));
    }
  });
}

function* refreshNotifications() {
  yield takeLatest([ACTION_REFRESH_NOTIFICATIONS], function* () {
    // Always refresh from page 1 to get latest notifications
    yield put(getNotificationsAPI(1, 10));
  });
}

function* handleGetNotificationsSuccess() {
  yield takeLatest([REQUEST_GET_NOTIFICATIONS_SUCCESS], function* () {
    // Could add any side effects here if needed
    yield;
  });
}

function* handleMarkReadSuccess() {
  yield takeLatest([REQUEST_MARK_NOTIFICATION_READ_SUCCESS], function* () {
    // Could add any side effects here if needed
    yield;
  });
}

export default function* userNotificationsSaga() {
  yield all([
    fork(getNotifications),
    fork(markNotificationRead),
    fork(refreshNotifications),
    fork(handleGetNotificationsSuccess),
    fork(handleMarkReadSuccess),
  ]);
}
